export default {
    not_in_xero: {
        id: 0,
        name: "Not In Sawfish",
    },
    in_xero: {
        id: 1,
        name: "In Sawfish",
    },
    paid: {
        id: 2,
        name: "PAID",
    },
    approved: {
        id: 3,
        name: 'APPROVED'
    }
};
